// src/utils/contracts.js
export const CONTRACT_ADDRESS = "0x660137AB80CC178C6fAD6DCDC27B2C4EA673AF83"; 
export const TOKEN_ADDRESS = "0xfD32aD4b1f3495F54E6CcDA0b0B943b14F008616"; 
export const OWNER_ADDRESS = "0xc62183f5167f3695395e949adab80d95ace59afd"; 

export const CONTRACT_ABI = [
  {
    "inputs": [{ "internalType": "address", "name": "referrer", "type": "address" }],
    "name": "claimAirdrop", 
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
  }
];

// ABI ERC20 Lengkap untuk Read & Write
export const ERC20_ABI = [
  // Read
  {
    constant: true,
    inputs: [{ name: "_owner", type: "address" }],
    name: "balanceOf",
    outputs: [{ name: "balance", type: "uint256" }],
    type: "function",
  },
  {
    constant: true,
    inputs: [],
    name: "decimals",
    outputs: [{ name: "", type: "uint8" }],
    type: "function",
  },
  // Write
  {
    constant: false,
    inputs: [
      { name: "_to", type: "address" },
      { name: "_value", type: "uint256" }
    ],
    name: "transfer",
    outputs: [{ name: "", type: "bool" }],
    type: "function"
  }
];